module.exports = __webpack_public_path__ + "img/humanBottomBg.6fabdcce.png";